import React, { useState, useRef, useMemo } from 'react';
import { toast, ToastContainer } from 'react-toastify';
import { Table, Button, FloatingLabel, Form } from 'react-bootstrap';
import 'react-toastify/dist/ReactToastify.css';
import { get } from '../../../services/apiController';
import { GrDocumentExcel } from 'react-icons/gr';
import Kitchen from '../../../components/Kitchen';
import Item from '../../../components/item';

const JWTransferReport = ({ reportType }) => {
  const [data, setData] = useState([]);
  const clickToDownload = useRef(null);
  const [state, setState] = useState({
    kitchenId: '',
    itemId: '',
    dateFrom: '',
    dateTo: '',
  });
  const jwType = 'JW';

  const FetchReport = (download = false) => {
    if (!state.dateFrom || !state.dateTo) {
      toast.error('Please select invoice between dates');
      return;
    }
    let url = `/inv/report/jw-transfer/?kitchenId=${state.kitchenId}&itemId=${state.itemId}&dateFrom=${state.dateFrom}&dateTo=${state.dateTo}&download=${download}&reportType=${reportType}`;
    get(url)
      .then((res) => {
        if (download) {
          clickToDownload.current.href = `${process.env.REACT_APP_BASE_URL}/file/download?filePath=${res.data.filePath}`;
          setTimeout(() => {
            clickToDownload.current.click();
          }, 500);
        } else {
          setData(res?.data);
        }
      })
      .catch((err) => {
        toast.error(err?.response?.data.data.message || err?.message);
      });
  };

  useMemo(() => {
    if (reportType && state.dateFrom && state.dateTo) {
      FetchReport();
    }
  }, [reportType]);

  return (
    <>
      <ToastContainer />
      <div className="card">
        <div className="card-header white-color" style={{ padding: '1rem 1.7rem' }}>
          <div className="col-3">
            <div className="d-flex" style={{ height: '100%', alignItems: 'center' }}>
              <h4 className="card-title" style={{ fontSize: '16px' }}>
                JW Vendor Report {reportType === 'grn-wise' ? '(GRN Wise)' : '(Invoice Wise)'}
              </h4>
            </div>
          </div>
          <div className="card-header-actions col-9 d-flex justify-content-end">
            <div style={{ maxWidth: '200px', marginRight: '20px' }} className="mb-3">
              <Kitchen
                query={'factoryId=116&type=JW'}
                kitchenId={state.kitchenId}
                onChange={(kitchenId) => setState({ ...state, kitchenId })}
                name={'kitchenId'}
                label="Select Vendor"
              />
            </div>
            <div style={{ maxWidth: '200px', marginRight: '20px' }} className="mb-3">
              <Item
                itemId={state.itemId}
                name="itemId"
                onChange={(itemId) => {
                  setState({ ...state, itemId });
                }}
                query={jwType === 'JW' ? 'type=JW' : ''}
                // type={jwType}
              />
            </div>
            <div style={{ maxWidth: '200px', marginRight: '20px' }}>
              <FloatingLabel className="mb-3" controlId="floatingInput" label="Start Date">
                <Form.Control value={state.dateFrom} onChange={(e) => setState({ ...state, dateFrom: e.target.value })} type="date" />
              </FloatingLabel>
            </div>
            <div style={{ maxWidth: '200px', marginRight: '20px' }}>
              <FloatingLabel className="mb-3" controlId="floatingInput" label="End Date">
                <Form.Control value={state.dateTo} onChange={(e) => setState({ ...state, dateTo: e.target.value })} type="date" />
              </FloatingLabel>
            </div>
            <div style={{ maxWidth: '200px', marginRight: '20px', alignContent: 'center' }}>
              <Button onClick={() => FetchReport()} type="submit" className="btn app-btn-default dark-color">
                Apply
              </Button>
            </div>
            <div style={{ alignContent: 'center' }}>
              <GrDocumentExcel
                title="Download Excel"
                className="react-icons green"
                style={{ width: '30px', height: '30px', cursor: 'pointer' }}
                onClick={() => FetchReport(true)}
              />
              <a ref={clickToDownload} href="/" target="_blank" className="hiddenItem">
                HiddenClick
              </a>
            </div>
          </div>
        </div>
        <div className="card-body px-0 vehicle-requests-table pt-0 pb-0">
          <div className="row">
            <div className="col">
              <Table responsive striped bordered>
                <thead>
                  <tr>
                    {data?.frontendHeader?.map((field, index) => (
                      <th key={index} dangerouslySetInnerHTML={{ __html: field }} />
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {data?.groupedReponse?.map((item, index) => {
                    const rowSpan = item?.item_details?.length;
                    const item_details = item?.item_details;
                    const transferAvgRate = isNaN(item_details[0]?.total_amount / item_details[0]?.total_issued_quantity)
                      ? 0
                      : item_details[0]?.total_amount / item_details[0]?.total_issued_quantity;
                    return (
                      <>
                        <tr key={item?.id}>
                          <td rowSpan={rowSpan}>{index + 1}</td>
                          <td rowSpan={rowSpan}>{item.kitchen_name}</td>
                          <td>{`${item_details[0].item_name} (${item_details[0].item_unit})`}</td>
                          <td>{item_details[0]?.hsnCode}</td>
                          <td>
                            {item_details[0]?.closing_total_issued_quantity -
                              item_details[0]?.closing_total_received_quantity -
                              item_details[0]?.closing_total_damaged_quantity}
                          </td>
                          <td>{item_details[0]?.total_issued_quantity}</td>
                          <td>{(item_details[0]?.total_amount).toFixed(2)}</td>
                          <td>{item_details[0]?.total_received_quantity}</td>
                          <td> {(item_details[0]?.total_received_quantity * transferAvgRate).toFixed(2)}</td>
                          <td>{item_details[0]?.total_damaged_quantity}</td>
                          <td> {(item_details[0]?.total_damaged_quantity * transferAvgRate).toFixed(2)}</td>
                          <td>
                            {item_details[0]?.closing_total_issued_quantity -
                              item_details[0]?.closing_total_received_quantity -
                              item_details[0]?.closing_total_damaged_quantity +
                              item_details[0]?.total_issued_quantity -
                              item_details[0]?.total_received_quantity -
                              item_details[0]?.total_damaged_quantity}
                          </td>
                        </tr>
                        {item_details.map((detail, _index) => {
                          if (_index === 0) {
                            return null;
                          }
                          const transferAvgRate = isNaN(detail?.total_amount / detail?.total_issued_quantity)
                            ? 0
                            : detail?.total_amount / detail?.total_issued_quantity;
                          return (
                            <tr key={_index}>
                              <td style={{ padding: '.6rem .5rem' }}>{`${detail.item_name} (${detail.item_unit})`}</td>
                              <td style={{ padding: '.6rem .5rem' }}>{detail.hsnCode}</td>
                              <td style={{ padding: '.6rem .5rem' }}>
                                {detail.closing_total_issued_quantity -
                                  detail.closing_total_received_quantity -
                                  detail?.closing_total_damaged_quantity}
                              </td>
                              <td style={{ padding: '.6rem .5rem' }}>{detail?.total_issued_quantity}</td>
                              <td style={{ padding: '.6rem .5rem' }}>{(detail?.total_amount).toFixed(2)}</td>
                              <td style={{ padding: '.6rem .5rem' }}>{detail?.total_received_quantity}</td>
                              <td style={{ padding: '.6rem .5rem' }}>{(detail?.total_received_quantity * transferAvgRate).toFixed(2)}</td>
                              <td style={{ padding: '.6rem .5rem' }}>{detail?.total_damaged_quantity}</td>
                              <td style={{ padding: '.6rem .5rem' }}>{(detail?.total_damaged_quantity * transferAvgRate).toFixed(2)}</td>
                              <td style={{ padding: '.6rem .5rem' }}>
                                {detail.closing_total_issued_quantity -
                                  detail.closing_total_received_quantity -
                                  detail?.closing_total_damaged_quantity +
                                  detail.total_issued_quantity -
                                  detail.total_received_quantity -
                                  detail?.total_damaged_quantity}
                              </td>
                            </tr>
                          );
                        })}
                      </>
                    );
                  })}
                </tbody>
              </Table>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default JWTransferReport;
